import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 默认样式
import "@/assets/css/iconfont.css";
import "@/assets/css/common.css";

// 无缝滚动组件
import vue3SeamlessScroll from "vue3-seamless-scroll";

createApp(App).use(store).use(router).use(vue3SeamlessScroll).mount("#app");
